import { isConciergeOffered } from '@/modules/misc/common/navbar/components/concierge';

const LIST_YOUR_VENUE_PATH = /^\/page\/list-your-venue\/?$/;

function isLinkVisible(link, user) {
  switch (link.name) {
    // On the List your venue page the entry only reloaded the page, which has sign-up buttons of its own
    case 'listYourVenue': {
      return !LIST_YOUR_VENUE_PATH.test(window.location.pathname);
    }
    // @todo TM-7783 remove after the business account MVP is validated
    // Where the Concierge is offered, its navbar entry takes over from this promo.
    case 'corporateBusinessJoin': {
      return Boolean(user.isCorporateEmail && !user.hasBusinessAccount) && !isConciergeOffered(user);
    }
    case 'corporateBusinessDashboard': {
      return Boolean(user.isCorporateEmail && user.hasBusinessAccount);
    }
    // A company without online payments has no payouts to read, and the Venue Cabinet sub-navigation
    // hides the same link on the same condition.
    case 'payouts': {
      return Boolean(user.paymentsEnabled);
    }
    default:
      return true;
  }
}

// Children are filtered on the same rules as their parent: the layered mobile menu renders them as
// rows of a sub-panel, so a link left in a child list is a link on screen.
export function filterLinks({ links, user }) {
  return links
    .filter(link => isLinkVisible(link, user))
    .map(link => (Array.isArray(link.children)
      ? { ...link, children: link.children.filter(child => isLinkVisible(child, user)) }
      : link));
}
